import "./index.scss";

import React, {useState} from "react";
//import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router-dom";

import Button from "@/components/components/Button";
import { ButtonColor } from "@/components/components/Button/button.enum";
import { H1 } from "@/components/components/Headings/H";
import icons from "@/components/icons";
import { SETTINGS } from "@/messenger/constants/routing";
import SettingsCardList from "@/messenger/containers/SettingsCardList";
import Notifications from "@/messenger/providers/Notifications";

//import { Chart, Close, Home, Menu, Plus,Support, Users   } from "@/components/icons";


interface TLeftSidebarProps {
    style?: React.CSSProperties
}



const LeftSidebarSettings = ({ style }: TLeftSidebarProps) => {
    const { t } = useTranslation(); 
    const history = useHistory();
    const showBack = false;
        
    const { id: parentSettingsId, child: childSettingsId } = useParams<any>();
    const [settingsTab, setSettingsTab] = useState(parentSettingsId?parentSettingsId:"personal");
    
    const openPreviousSection = (): void => {
        if (childSettingsId) {
            history.push(`/${SETTINGS}`);
        } else if (parentSettingsId) {
            history.push(`/${SETTINGS}`);
        }
    };

    return (
        <div className="c-left-sidebar-settings" role="application" aria-label="leftSidebar" style={style}>
            <div className="c-left-sidebar-settings__header">
                <div className="c-left-sidebar-settings-header-control" data-testid="headingControl">
                
                <H1>{t("Settings")}</H1>
                {showBack ? (
                <Button
                    id={"SETTINGS_BACK_BUTTON"}
                    icon={icons.ANGLE_LEFT}
                    color={ButtonColor.SECONDARY}
                    className={"c-left-sidebar-settings__button-back"}
                    onClick={openPreviousSection}
                    ariaLabel={"Settings Back Button"}
                >
                    <div className={"c-left-sidebar-settings__button-back-text"}>{t("Back")}</div>
                </Button>
                ):""}
                </div>
            </div>
            <SettingsSwitcher settingsTab={settingsTab} setSettingsTab={setSettingsTab}/>   
            <SettingsCardList mode={settingsTab}/>
            <Notifications />
            
        </div>
    );
};

const SettingsSwitcher = (props) => {
    const { t } = useTranslation(); 
    const settingsTab = props.settingsTab;
    const setSettingsTab = props.setSettingsTab;
    return (
        <div className="c-left-sidebar-settings__widget-selector">
            <div className="c-left-sidebar-settings__widget-selector__tabs">
                <button
                    id={"WIDGETS_TAB_BUTTON"}
                    className={`c-left-sidebar-settings__widget-selector__tabs-${settingsTab === "personal" ? "active" : "inactive"}`} 
                    onClick={() => setSettingsTab("personal")}
                >
                    {t("Personal")}
                </button>
                <button
                    id={"TIMELINE_TAB_BUTTON"}
                    className={`c-left-sidebar-settings__widget-selector__tabs-${settingsTab === "workspace" ? "active" : "inactive"}`}
                    onClick={() => setSettingsTab("workspace")}
                >
                    {t("Workspace")}
                </button>
            </div>
        </div>
    );
};

export default LeftSidebarSettings;